import coinbaseIcon from "images/exchanges/coinbase.svg";
import {
  BASE_EXCHANGES_ICONS_PATH,
  BASE_SYMBOLS_ICONS_PATH,
} from "@shared/common/constants.ts";

export const getIconAssetName = (asset: string | undefined) => {
  if (!asset) return "";
  let parsedAsset = asset;
  const numberPrefixRegex = /^(\d+).*/;
  const match = asset.match(numberPrefixRegex);
  if (match && match.length > 1) {
    const prefix = match[1];
    const parsedPrefix = parseInt(prefix);
    if (parsedPrefix >= 10) {
      parsedAsset = asset.replace(prefix, "");
    }
  }
  return parsedAsset.toLowerCase();
};

export const getAssetIconSuffix = (asset: string | undefined) => {
  const assetName = getIconAssetName(asset);
  if (!assetName) return "";
  return BASE_SYMBOLS_ICONS_PATH + assetName;
};

export const getExchangeIconSuffix = (exchange: string): string => {
  const fileName = exchange
    .toLowerCase()
    .replace(".", "_")
    .split(" ")
    .join("_");
  return BASE_EXCHANGES_ICONS_PATH + fileName.split(" ").join("_");
};

const getBaseIconsUrl = () => {
  if (import.meta.env.PROD) {
    return "";
  } else {
    return "https://dashboard.cornix.io";
  }
};

export const getAssetIcon = (asset: string | undefined) => {
  const assetSuffix = getAssetIconSuffix(asset);
  if (!assetSuffix) return "";
  return getBaseIconsUrl() + "/static/" + assetSuffix;
};

// Logos served locally instead of from the server's static icons: Coinbase's
// current mark (blue disc, white C) on a transparent background.
const LOCAL_EXCHANGE_ICONS: Record<string, string> = {
  coinbase: coinbaseIcon,
  coinbase_advanced_spot: coinbaseIcon,
  coinbase_advanced_futures: coinbaseIcon,
};

export const getExchangeIcon = (exchange: string) => {
  const local =
    LOCAL_EXCHANGE_ICONS[
      getExchangeIconSuffix(exchange).replace(BASE_EXCHANGES_ICONS_PATH, "")
    ];
  if (local) return local;
  return getBaseIconsUrl() + "/static/" + getExchangeIconSuffix(exchange);
};
